<template>
  <div id="app" class="relative" @click="closeMenu()">
    <cookie-personalization id="cookie-personalization" class="hidden"></cookie-personalization>
    <cookie-policy></cookie-policy>
    <app-nav></app-nav>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<style lang="scss">
  #app {
    font-family: Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  main {
    min-height: 90vh;
    background: center/cover no-repeat url('./assets/images/background.jpg');
    color: white;
  }
  @media(min-width: 1536px) { // 2xl
     main {
      min-height: 80vh;
    }
  }
  @media(min-width: 2560px) { // 3xl
    main {
      min-height: 81vh;
    }
  }
  @media(min-width: 3840px) { // 5xl
    main {
      min-height: 90vh;
    }
  }
</style>

<script>
import AppNav from '@/components/AppNav.vue'
import AppFooter from '@/components/AppFooter.vue'
import CookiePolicy from '@/components/CookiePolicy.vue'
import CookiePersonalization from './components/CookiePersonalization.vue'

export default {
  name: 'app',
  components: {
    AppNav,
    AppFooter,
    CookiePolicy,
    CookiePersonalization
  },
  methods: {
    closeMenu () {
      var target = event.target
      var menu = document.getElementById('language-menu')
      if (target.closest('#language-wrapper') === null && !menu.classList.contains('hidden')) {
        var currentLanguage = document.getElementById('current-language')
        currentLanguage.classList.remove('chevron-up')
        currentLanguage.classList.add('chevron-down')
        menu.classList.add('hidden')
      }
    }
  }
}
</script>